import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';
import { ClockIcon } from '../../components/tickets/Tickets';
import TthOrderCommentModal from './TthOrderCommentModal';

/**
 * "Lịch sử trạng thái" cho Đơn TTH — mirror `HistoryInfo.jsx` (đơn hàng thường), rút gọn: TTH không
 * có sub-detail rows và không có luồng "Xác nhận xử lý đơn chậm". Nhúng `TthOrderCommentModal` inline
 * bên dưới lịch sử, giống cách HistoryInfo nhúng OrderCommentModal.
 */
const TthOrderHistoryInfo = ({ tthOrderId, onClose }) => {
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});

  useEffect(() => {
    fetchLogs(tthOrderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tthOrderId]);

  const handleModalClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  const fetchLogs = async (id) => {
    try {
      const response = await axiosInstance.get('/api/tth-orders/findTthOrderLogs', { params: { id } });
      if (response.data?.success === false) {
        toast.error(response.data?.message || 'Không có quyền xem lịch sử trạng thái.');
        setShow(false);
        return;
      }
      setModel(response.data);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="mb-3 normal-form">
        <div className="modal-content">
          <div className="modal-header position-relative flex-between">
            {model.data && model.data.order && (
              <span className="record_id">Code: {model.data.order.orderCode}</span>
            )}
            <h5 className="modal-title">Lịch sử trạng thái</h5>
            <button type="button" className="btn-close" onClick={handleModalClose} aria-label="Đóng"></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12 mb-3">
                {model.data && (!model.data.items || model.data.items.length === 0) && (
                  <div className="text-muted">Chưa có lịch sử thay đổi</div>
                )}
                {model.data && model.data.items && model.data.items.map((item, index) => (
                  <div className="history-item" data-progress-index={index} key={item.id ?? index}>
                    <div className="progress-name">{item.description || item.progressName}</div>
                    <div className="progress-time"><ClockIcon /> <span>{general.formatDateTime3(item.createdAt)}</span></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row normal-form">
        <TthOrderCommentModal tthOrderId={tthOrderId} />
      </div>
      <div className="modal-footer justify-content-between">
        <div></div>
        <button type="button" className="btn-sm btn btn-primary" onClick={handleModalClose}>
          Đóng
        </button>
      </div>
    </Modal>
  );
};

export default TthOrderHistoryInfo;
